import { ReactNode, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeProvider } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { createAppTheme } from '../../const/themes'
import { currentLanguage } from '../../utils/language'

const LocalizedThemeProvider = ({ children }: { children: ReactNode }) => {
  const { i18n } = useTranslation()
  const language = currentLanguage(i18n.resolvedLanguage)
  const theme = useMemo(() => createAppTheme(language), [language])

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={language}>
        {children}
      </LocalizationProvider>
    </ThemeProvider>
  )
}

export default LocalizedThemeProvider
